import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray, FormSection } from 'redux-form';
import { Checkbox, TextField, DatePicker, SelectField, TimePicker } from 'redux-form-material-ui';
import { MenuItem, FlatButton, IconButton } from 'material-ui';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import AddIcon from 'material-ui/svg-icons/content/add';
import _ from 'lodash';
import humanize from 'humanize-string';
import ConditionForm from './ConditionForm';
import { CAMPAIGN_FORM_KEYS as FORM_KEYS } from '../../../constants';
import triggerTypes from '../../../../../config/triggerTypes.json';
import { presence } from 'dash-front/helpers/validation';

const yCenter = { display: 'flex', alignItems: 'center' };

const onConditionAdd = fields => () => fields.push({});
const onConditionRemove = (fields, index) => () => {
    if (fields.length > 1) {
        fields.remove(index);
    }
};

class ConditionFormArray extends React.Component {
    render() {
        const { fields, triggerType } = this.props;
        return (
            <div>
                {fields.map((field, index) => {
                    return (
                        <div key={field} style={yCenter}>
                            <span style={{ margin: '16px 8px 0px 0px' }}>{index + 1}.</span>
                            <FormSection name={field}>
                                <ConditionForm triggerType={triggerType} />
                            </FormSection>
                            <IconButton
                                style={{ margin: '16px 8px 0px 0px' }}
                                label={'x'}
                                onTouchTap={onConditionRemove(fields, index)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </div>
                    );
                })}
                <FlatButton primary label={'Add condition'} onTouchTap={onConditionAdd(fields)} icon={<AddIcon />} />
            </div>
        );
    }
}

export const TriggerForm = ({ onTriggerChange }) => {
    return (
        <Field
            validate={presence}
            name={FORM_KEYS.RULES.KEY}
            label={'Trigger'}
            component={SelectField}
            onChange={onTriggerChange}
        >
            {triggerTypes.map(obj => (
                <MenuItem key={obj.trigger} value={obj.trigger} primaryText={humanize(obj.trigger)} />
            ))}
        </Field>
    );
};

TriggerForm.propTypes = {
    onTriggerChange: PropTypes.func
};

export const RuleForm = ({ triggerType, onTriggerChange }) => (
    <div>
        <TriggerForm onTriggerChange={onTriggerChange} />
        <br />
        <FieldArray triggerType={triggerType} name={FORM_KEYS.RULES.CONDITIONS.ARRAY} component={ConditionFormArray} />
    </div>
);

RuleForm.propTypes = {
    triggerType: PropTypes.string,
    onTriggerChange: PropTypes.func
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/RuleForm.js
 **/